export const getCommonAppTableColumns = ({
  showTableFilter,
  filteredInfo,
  appList,
  createSorterForAlertStatus,
  createTableFilterList,
  createTableFilterStaticList,
  GmtToLocal,
}) => [
  {
    title: "Name",
    dataIndex: "name",
    width: "20%",
    key: "name",
    filters: showTableFilter
      ? createTableFilterList(appList, "name")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.name || null,
    // showMultiColorSeverity: true,
    customStyle: { width: "100%" },
    onFilter: (value, record) =>
      record.name.toLowerCase().includes(value.toLowerCase()),
    // sorter: (a, b) =>
    //   new Date(GmtToLocal(a.createdon)) - new Date(GmtToLocal(b.createdon)),
    // sortDirections: ["descend", "ascend"],
  },
  {
    title: "Version",
    dataIndex: "version",
    width: "20%",
    key: "version",
    filters: showTableFilter
      ? createTableFilterList(appList, "version")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.version || null,
    // showMultiColorSeverity: true,
    customStyle: { width: "100%" },
    onFilter: (value, record) =>
      record.version.toLowerCase().includes(value.toLowerCase()),
    // sorter: (a, b) =>
    //   new Date(GmtToLocal(a.createdon)) - new Date(GmtToLocal(b.createdon)),
    // sortDirections: ["descend", "ascend"],
  },


  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: "20%",
    filters: showTableFilter
      ? createTableFilterList(appList, "status")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.status || null,
    // showMultiColorSeverity: true,
    customStyle: { width: "100%" },
    onFilter: (value, record) => record.status.toLowerCase().includes(value.toLowerCase()),
    // sorter: (a, b) =>
    //   new Date(GmtToLocal(a.createdon)) - new Date(GmtToLocal(b.createdon)),
    // sortDirections: ["descend", "ascend"],
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    width: "20%",
    filters: showTableFilter
      ? createTableFilterList(appList, "type")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.type || null,
    onFilter: (value, record) => record.type.toLowerCase().includes(value.toLowerCase()),
    // sorter: (a, b) =>
    //   new Date(GmtToLocal(a.createdon)) - new Date(GmtToLocal(b.createdon)),
    // sortDirections: ["descend", "ascend"],
  },
  {
    title: "Image",
    dataIndex: "image",
    key: "image",
    width: "20%",
    filters: showTableFilter
      ? createTableFilterList(appList, "image")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.image || null,
    // showMultiColorSeverity: true,
    customStyle: { width: "100%" },
    onFilter: (value, record) => record.image.toLowerCase().includes(value.toLowerCase()),
    // sorter: (a, b) =>
    //   new Date(GmtToLocal(a.createdon)) - new Date(GmtToLocal(b.createdon)),
    // sortDirections: ["descend", "ascend"],
  },
  {
    title: "Actions",
    dataIndex:"actions",
    display:"flex",
    flexDirection:"row",
    editColumn:true,
    hasNoText:true,
    customStyle:{minWidth: "60px"},
  },
];